module.exports = __webpack_public_path__ + "img/icons8_disney_plus_1.e2a012a6.svg";